import { PrequalEffects } from './prequal.effects';
import { RootEffects } from './root.effects';

export const effects = [PrequalEffects, RootEffects];
